<template>
  <div class="page-container">
    <TableList
      style="min-height: 80vh"
      :columns="columns"
      :tableData="dataSource"
      bordered
      :loading="loading"
      :scroll="{}"
      :pagination="ipagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" style="margin-bottom: 20px">
        <j-dict-select-tag
          placeholder="请选择年级"
          v-model="queryParam.gradeId"
          style="width: 140px; margin-right: 15px"
          dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
          allowClear
        />
        <j-dict-select-tag
          placeholder="请选择班级"
          v-model="queryParam.classId"
          style="width: 140px; margin-right: 15px"
          :dictCode="
            'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
          "
          :disabled="!queryParam.gradeId"
          :async="true"
        />
        <a-range-picker
          v-model="rangeDate"
          style="width: 220px; margin-right: 15px"
          @change="changeDateRange"
        />
        <j-dict-select-tag
          v-model="queryParam.careList"
          placeholder="关爱等级"
          dictCode="care_list"
          style="width: 140px; margin-right: 15px"
        />
        <a-input-search
          v-model="queryParam.studentName"
          placeholder="请输入学生名称"
          style="width: 170px; margin-right: 15px"
          @change="searchName"
        />
        <a-button type="primary" @click="loadData">查询</a-button>
        <!-- <a-button type="primary" icon="plus">新增</a-button> -->
        <a-button type="primary" icon="download" style="margin: 0 15px" @click="handleExportXls">
          导出
        </a-button>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="showAddLabel(record)">+标签</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
          <a-divider type="vertical" />
          <span @click="addLedger(record)" class="action-span">添加台账</span>
          <a-divider type="vertical" />
          <span @click="addVisitRecord(record)">添加家访记录</span>
        </div>
      </template>
    </TableList>
    <!-- 辅导台账 -->
    <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData" />
    <!-- 评估 -->
    <AssessModal ref="assessModalRef" />
    <AddLabelModal ref="addLabelModalRef" @close="loadData" />
    <!-- 家访记录 -->
    <AddVisitRecordModal ref="visitRecordModalRef" @close="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { simpleDebounce, getDictCodeData } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import AddLabelModal from '@/comUi/AddLabelModal'
import moment from 'moment'
import AddLedgerModal from '@/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal'
import AddVisitRecordModal from '@/views/school/mentalHealth/CrisisIntervent/components/AddVisitRecordModal'

export default {
  name: 'FirstGearLife',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    AssessModal,
    AddLabelModal,
    AddLedgerModal,
    AddVisitRecordModal
  },
  data() {
    return {
      rangeDate: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '学生',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '关爱等级',
          dataIndex: 'careList',
          align: 'center',
          customRender: (_, record) => {
            const res = getDictCodeData('care_list', record.careList)
            return res.text
          },
        },
        {
          title: '提醒次数',
          dataIndex: 'wranNum',
          align: 'center',
        },
        {
          title: '辅导次数',
          dataIndex: 'tutoringNum',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/studentInfo/getStudentLifeRecords',
        exportXlsUrl: '/aigoes/studentInfo/exportStudentArchiveList',
      },
    }
  },
  methods: {
    addLedger(row){
      this.$refs.addLedgerModalRef.showModal({
        gradeId:row.gradeId,
        classId:row.classId,
        studentId:row.studentId
      },"append")
    },
    addVisitRecord(row) {
      this.$refs.visitRecordModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target.value.trim()
      this.loadData(1)
    }, 500),
    changeDateRange(date) {
      this.queryParam.beginDate = date[0] ? moment(date[0]).format('YYYY-MM-DD') : undefined
      this.queryParam.endDate = date[1] ? moment(date[1]).format('YYYY-MM-DD') : undefined
    },
    showAddLabel(record) {
      const recordData = {
        studentId: record.id,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }
      this.$refs.addLabelModalRef.show(recordData)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.id,
          pageName: '一生一档',
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
.action-span{
  display: inline-block;
  margin-right: 10px;
  color: #0077fa;
}
</style>
